<template>
  <div class="page-add-lxgc">
    <div class="form-section">
      <a-form :form="form" layout="inline">
        <div class="form-row">
          <span class="form-label required">报修地点</span>
          <div style="display: flex; align-items: center;">
            <div style="width: 300px;">
              <a-form-item style="margin-bottom: 0;">
                <a-select
                  v-decorator="[
                    'xqDm',
                    { rules: [{ required: true, message: '请选择校区！' }] }
                  ]"
                  placeholder="请选择校区"
                  allowClear
                  show-search
                  :filter-option="filterOption"
                  class="form-input"
                  @change="handleSchoolChange"
                >
                  <a-select-option
                    v-for="item in schoolData"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div style="width: 300px; margin-left: 12px;">
              <a-form-item v-if="buildData.length > 0" style="margin-bottom: 0;">
                <a-select
                  v-decorator="[
                    'xqJzId',
                    { rules: [{ required: true, message: '请选择楼宇！' }] }
                  ]"
                  placeholder="请选择楼宇"
                  allowClear
                  show-search
                  :filter-option="filterOption"
                  class="form-input"
                  @change="handleBuildChange"
                >
                  <a-select-option
                    v-for="item in buildData"
                    :key="item.id"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div style="width: 300px; margin-left: 12px;">
              <a-form-item v-if="buildData.length > 0 && roomData.length > 0" style="margin-bottom: 0;">
                <a-select
                  v-decorator="[
                    'qyfjh',
                    { rules: [{ required: true, message: '请选择房间号！' }] }
                  ]"
                  placeholder="请选择房间号"
                  allowClear
                  show-search
                  :filter-option="filterOption"
                  class="form-input"
                >
                  <a-select-option
                    v-for="item in roomData"
                    :key="item.id"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
        </div>
        <div class="form-row">
          <span class="form-label required">详细地址</span>
          <a-form-item>
            <a-input
              v-decorator="[
                'detailAddress',
                { rules: [{ required: true, message: '请输入详细地址！' }] }
              ]"
              placeholder="请输入详细地址"
              maxlength="200"
              class="form-input"
            />
          </a-form-item>
        </div>
        <div class="form-row">
          <span class="form-label">需求人姓名</span>
          <a-form-item>
            <a-input
              v-decorator="['requesterName']"
              placeholder="请输入"
              maxlength="200"
              class="form-input"
            />
          </a-form-item>
        </div>
        <div class="form-row">
          <span class="form-label">手机号</span>
          <a-form-item>
            <a-input
              v-decorator="[
                'phone',
                {
                  getValueFromEvent: (e) => e.target.value.replace(/\D/g, '').slice(0, 11),
                  rules: [
                    { pattern: /^1\d{10}$/, message: '请输入正确的11位手机号！' }
                  ]
                }
              ]"
              placeholder="请输入11位手机号"
              maxlength="11"
              class="form-input"
            />
          </a-form-item>
        </div>
        <div class="form-row">
          <span class="form-label">施工类型</span>
          <a-form-item>
            <a-select
              v-decorator="['bxlxId']"
              placeholder="请选择"
              allowClear
              class="form-input"
            >
              <a-select-option
                v-for="item in bxlxList"
                :key="item.id"
                :value="item.id"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="form-row">
          <span class="form-label">项目描述</span>
          <a-form-item>
            <a-textarea
              v-decorator="['projectDescription']"
              placeholder="请输入项目描述"
              :rows="4"
              :maxLength="2000"
              class="form-textarea"
            />
          </a-form-item>
        </div>
        <div class="form-row">
          <span class="form-label upload-label">上传项目图片（最多上传10个）</span>
          <a-form-item>
             <upload-picture v-decorator="['imgUrl']" :seenote="false" />
          </a-form-item>
        </div>
        <div class="form-row">
          <span class="form-label required">供应商</span>
          <a-form-item>
            <a-select
              v-decorator="[
                'gysId',
                { rules: [{ required: true, message: '请选择供应商！' }] }
              ]"
              placeholder="全部"
              allowClear
              show-search
              :filter-option="filterGys"
              class="form-input"
            >
              <a-select-option
                v-for="item in gysList"
                :key="item.id"
                :value="item.id"
              >{{ item.gysName }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </a-form>
    </div>

    <div class="footer-actions">
      <a-button type="primary" @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit" style="margin-left: 16px;">提交</a-button>
    </div>
  </div>
</template>

<script>
import UploadPicture from '../../components/upload/UploadPicture'

export default {
  name: 'LxgcAdd',
  components: {
    UploadPicture
  },
  data () {
    return {
      form: this.$form.createForm(this),
      gysList: [],
      bxlxList: [],
      schoolData: [],
      buildData: [],
      roomData: []
    }
  },
  mounted () {
    // 进入页面时重置表单，避免跨页面残留 imgUrl 等字段
    this.$nextTick(() => {
      this.form.resetFields()
    })
    this.loadGysList()
    this.loadBxlxList()
    this.loadSchoolList()
  },
  methods: {
    loadGysList () {
      this.$axios.post('/api/gysgl/list.do', { pageNum: 1, pageSize: 999 }).then(res => {
        const list = (res.data && res.data.list) || {}
        this.gysList = list.data || []
      })
    },
    loadBxlxList () {
      this.$axios.post('/api/xtgl/getBxlxList.do').then(res => {
        this.bxlxList = (res.data && res.data.data) || []
      })
    },
    loadSchoolList () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.schoolData = (res.data && res.data.data) || []
      })
    },
    handleSchoolChange (value) {
      this.form.setFieldsValue({ xqJzId: undefined, qyfjh: undefined })
      this.buildData = []
      this.roomData = []
      if (!value) {
        return
      }
      this.loadBuildList(value)
    },
    loadBuildList (xqdm) {
      this.$axios.post('/api/bxjl/getBxdd.do', { xqdm: xqdm, activeFlag: '1' }).then(res => {
        this.buildData = (res.data && res.data.data) || []
      })
    },
    handleBuildChange (value) {
      this.form.setFieldsValue({ qyfjh: undefined })
      this.roomData = []
      if (!value) {
        return
      }
      this.loadRoomList(value)
    },
    loadRoomList (lyId) {
      this.$axios.post('/api/bxjl/getBxdd.do', { lyId: lyId, activeFlag: '1' }).then(res => {
        this.roomData = (res.data && res.data.data) || []
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterGys (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleCancel () {
      this.$router.go(-1)
    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          // upload-picture 上传后通过表单 imgUrl 字段返回 [{id, fileName, fileFullName, ...}, ...]
          const imgList = values.imgUrl || []
          const tpId = imgList.map(item => item.id).filter(Boolean).join(',')
          const params = {
            xqDm: values.xqDm,
            xqJzId: values.xqJzId,
            qyfjh: values.qyfjh,
            address: values.detailAddress,
            requesterName: values.requesterName,
            phone: values.phone,
            bxlxId: values.bxlxId,
            gysId: values.gysId,
            fromType: '0',
            projectDescription: values.projectDescription,
            tpId: tpId || ''
          }
          this.$axios.post('/api/lxgc/save.do', params).then(() => {
            this.$message.success('新增成功！')
            this.$router.go(-1)
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-add-lxgc {
  background: #fff;
  padding: 24px;
  min-height: calc(100vh - 64px);

  .form-section {
    margin-bottom: 32px;
    padding-left: 50px;

    .ant-form {
      .ant-form-item {
        margin-bottom: 0;
      }
    }

    .form-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;

      .form-label {
        width: 90px;
        min-width: 90px;
        line-height: 32px;
        text-align: left;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding-left: 10px;

        &.required {
          padding-left: 0;

          &::before {
            content: '*';
            color: #f5222d;
            margin-right: 4px;
            font-family: SimSun, sans-serif;
          }
        }
      }

      .form-input {
        width: 300px;
      }

      .form-textarea {
        width: 600px;
      }

      .upload-label {
        white-space: normal;
        line-height: 22px;
        padding-top: 6px;
        word-break: break-all;
      }
    }
  }

  .footer-actions {
    text-align: center;
    padding: 24px 0;
  }
}
</style>
